export default __webpack_public_path__ + "locales/pt-BR/ChangeEmailDialog.json?hash=177f51b58c0453ae805ecec3cb462b97";